import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { CAPITALIZE } from "../../../utils/constants";

export default function BulkWaiverModal({
  open,
  onClose,
  setFormData,
  selectedServices,
  setSelectedServices,
}) {
  const initialState = {
    waiverReason: "",
    approvedBy: "",
    waiverType: "Percentage",
    waiverAmount: 0,
    waiverPercentage: 0,
  };

  const [data, setData] = useState(initialState);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    const parsedValue = type === "number" ? Number(value) : value;
    setData({
      ...data,
      [name]: parsedValue,
    });
  };
  const handleWaiverSubmit = (event) => {
    event.preventDefault();

    setFormData((prevState) => ({
      ...prevState,
      services: prevState?.services?.map((service) =>
        selectedServices?.includes(service?._id || service?.id)
          ? {
              ...service,
              waiver: {
                ...data,
                waiverPercentage:
                  data?.waiverType === "Percentage"
                    ? data?.waiverPercentage
                    : 0,
                waiverAmount:
                  data?.waiverType === "Amount" ? data?.waiverAmount : 0,
              },
            }
          : service
      ),
    }));

    setData(initialState);
    setSelectedServices([]);
    onClose();
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            maxWidth: "unset",
            width: { xs: "95vw", lg: "1100px" },
            bgcolor: "#E5F4FF",
            borderRadius: "20px",
          },
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: "20px",
          }}
        >
          <Typography sx={{ color: "rgba(93, 106, 130, 1)", fontSize: 20 }}>
            Bulk Waiver Details
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box component="form" onSubmit={handleWaiverSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                label="Waiver Reason"
                name="waiverReason"
                value={data?.waiverReason || ""}
                onChange={handleChange}
                fullWidth
                sx={{ bgcolor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                label="Approved By"
                name="approvedBy"
                value={data?.approvedBy || ""}
                onChange={handleChange}
                fullWidth
                sx={{ bgcolor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Autocomplete
                options={["Percentage", "Amount"]}
                getOptionLabel={(option) => CAPITALIZE(option) || ""}
                renderInput={(params) => (
                  <TextField {...params} label="Waiver Type" fullWidth />
                )}
                value={data?.waiverType || null}
                onChange={(_, newValue) =>
                  handleChange({
                    target: { name: "waiverType", value: newValue },
                  })
                }
                sx={{ bgcolor: "white" }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                type="number"
                label={
                  data?.waiverType === "Percentage" ? "Percentage" : "Amount"
                }
                name={
                  data?.waiverType === "Percentage"
                    ? "waiverPercentage"
                    : "waiverAmount"
                }
                value={
                  data?.waiverType === "Percentage"
                    ? data?.waiverPercentage || ""
                    : data?.waiverAmount || ""
                }
                onChange={handleChange}
                fullWidth
                sx={{ bgcolor: "white" }}
              />
            </Grid>
          </Grid>
          <Box sx={{ display: "flex", justifyContent: "center", mt: "20px" }}>
            <Button
              variant="contained"
              type="submit"
              sx={{
                textTransform: "none",
                backgroundColor: "rgba(1, 121, 176, 1)",
                width: "150px",
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
